import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../../../../config/endpoints.config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SrcPersonalInfInpService {
  constructor(private http: HttpClient) { }

  SearchAddress(pStrPostCode: any): Observable<any> {
    return this.http.post<any>(EndpointsConfig.common.searchAddress, { PostCode: pStrPostCode });
  }
  getMstUser(): Observable<any> {
    return this.http.get<any>(EndpointsConfig.common.getMstUser);
  }
  CheckExistCourse(pSearch: any): Observable<any> {
    return this.http.post<any>(EndpointsConfig.reservation.checkExistCourse, pSearch);
  }
  CheckCourseRegistered(pSearch: any): Observable<any> {
    return this.http.post<any>(EndpointsConfig.reservation.checkCourseRegistered, pSearch);
  }
}
